/*
 *
 *  * Copyright(c) 2021 General Electric Company. All rights reserved.
 *  *
 *  * The copyright to the computer software herein is the property of
 *  * General Electric Company. The software may be used and/or copied only
 *  * with the written permission of General Electric Company or in accordance
 *  * with the terms and conditions stipulated in the agreement/contract
 *  * under which the software has been supplied.
 *
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipComponent } from './tooltip.component';
import { TooltipDirective } from './tooltip.directive';
import { PipesModule } from '../../pipes/pipes.module';

@NgModule({
  declarations: [TooltipComponent, TooltipDirective],
  exports: [TooltipComponent, TooltipDirective],
  entryComponents: [TooltipComponent],
  imports: [CommonModule, PipesModule]
})
export class TooltipModule {}

export { TooltipComponent, TooltipDirective };
